// extracted by mini-css-extract-plugin
export default {"challengeStatsLabel":"StatisticsSummary_challengeStatsLabel__xdqqJ"};